import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as HeartImage } from '../../../assets/svg/heart-image.svg';
import { ReactComponent as BrainImage } from '../../../assets/svg/brain-image.svg';
import { ReactComponent as KidneyImage } from '../../../assets/svg/kidney-image.svg';
import { ReactComponent as LungImage } from '../../../assets/svg/lungs-image.svg';
import { ReactComponent as GreenCircle } from '../../../assets/svg/green-circle.svg';
import { ReactComponent as RedCircle } from '../../../assets/svg/red-circle.svg';

import InfoCardListSelection from '../../../components/InfoCardListSelection';

const CARD_IMAGE_MAPPER = {
  'cardiovascular': HeartImage,
  'cognitive': BrainImage,
  'renal': KidneyImage,
  'respiratory': LungImage,
};

const STATUS_ICON_MAPPER = {
  'above_reference': GreenCircle,
  'below_reference': RedCircle,
}

const LongevityCheckInfoCardListSelection = ({
  className,
  description,
  wellbeingScores,
}) => {
  const { ageAndSexMatched, globalPopulation } = wellbeingScores;

  const ageAndSexMatchedCards = ageAndSexMatched.map(
    (card) => ({
      ...card,
      imageLeft: CARD_IMAGE_MAPPER[card.type],
      imageRight: STATUS_ICON_MAPPER[card.status],
      text: card.score !== null ? `${card.text} (${card.score})` : card.text,
    }),
  );
  const globalPopulationCards = globalPopulation.map(
    (card) => ({
      ...card,
      imageLeft: CARD_IMAGE_MAPPER[card.type],
      imageRight: STATUS_ICON_MAPPER[card.status],
      text: card.score !== null ? `${card.text} (${card.score})` : card.text,
    }),
  );
  return (
    <InfoCardListSelection
      className={className}
      description={description}
      options={[
        {
          id: 'age-sex-matched',
          label: (
            <FormattedMessage
              id='test-result.age-sex-matched'
              defaultMessage='Age & Sex Matched'
            />
          ),
          cards: ageAndSexMatchedCards,
        },
        {
          id: 'global-population',
          label: (
            <FormattedMessage
              id='test-result.global-population'
              defaultMessage='Global Population'
            />
          ),
          cards: globalPopulationCards,
        },
      ]}
    />
  )
};

LongevityCheckInfoCardListSelection.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  wellbeingScores: PropTypes.object.isRequired,
};

export default LongevityCheckInfoCardListSelection;
